// frontend/src/components/themed/ThemedBadge.js - Professional themed badge component
import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ThemedBadge = ({ 
  variant = 'default',
  size = 'md',
  children,
  className = '',
  dot = false,
  ...props 
}) => {
  const { components, cn } = useTheme();

  // Size classes
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-sm',
    lg: 'px-3 py-1 text-base',
  };

  // Build badge classes
  const badgeClasses = cn(
    'inline-flex items-center font-medium rounded-full',
    sizeClasses[size],
    components.badge[variant] || components.badge.default,
    className
  );

  return (
    <span className={badgeClasses} {...props}>
      {dot && (
        <span className={cn(
          'rounded-full',
          size === 'sm' ? 'w-1.5 h-1.5 mr-1' : 'w-2 h-2 mr-1.5',
          variant === 'success' ? 'bg-emerald-500' :
          variant === 'error' ? 'bg-red-500' :
          variant === 'warning' ? 'bg-amber-500' :
          variant === 'primary' ? 'bg-blue-500' :
          'bg-gray-500'
        )} />
      )}
      {children}
    </span>
  );
};

export default ThemedBadge;